import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=dd3044a0&scoped=true&"
import script from "./Education.vue?vue&type=script&lang=js&"
export * from "./Education.vue?vue&type=script&lang=js&"
import style1 from "./Education.vue?vue&type=style&index=1&id=dd3044a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3044a0",
  null
  
)

export default component.exports